<template>
  <div class="container-card-course-1 th-card-hover th-hover-pointer th-card">
    <div
      class="wishlist"
      :class="[isClickedWishlist || content.isWishlist ? 'active' : null, !isDesktopView || (isDesktopView && ( isClickedWishlist || content.isWishlist)) ? 'wishlist-active' : 'wishlist-hover']"
      @click.prevent="changeWishlist"
    >
      <bookmark-icon :stroke="isClickedWishlist || content.isWishlist ? '#ffffff' : null" />
    </div>
    <router-link @click.native="toDetail()" :to="{ name: 'Detail Course', params: { id: content.key } }">
      <div>
        <div class="image">
          <img
            :src="
              content.thumbnailSmall
                ? backendUrl + content.thumbnailSmall
                : content.thumbnail
                ? backendUrl + content.thumbnail
                : '/img/thumbnail/empty.png'
            "
            :alt="content.title"
          />
        </div>
        <div class="content">
          <div class="mb-2">
            <h4 class="title text-black">{{ content ? content.title : "-" }}</h4>
            <p class="text-black">{{ content ? content.instructor : "-" }}</p>
            <template v-if="content">
              <rating
                class="text-black"
                :rating="content.rating || 0"
                :reviews="
                  Array.isArray(content.reviews)
                    ? content.reviews.length
                    : content.reviews
                "
              />
            </template>
          </div>
          <div class="price-tag">
            <router-link v-if="$route.name !== 'Temukan'" style="" :to="{ name: 'Temukan', query: { category: content.category
                      ? [content.category.name]
                      : typeof content.categoryId === 'object'
                      ? content.categoryId.name
                      : []} }">
              <div class="th-hover-scale">
                <va-lozenge
                  :class="
                    content.category || typeof content.categoryId === 'object'
                      ? ''
                      : 'invisible'
                  "
                  size="lg"
                  :uppercase="false"
                  type="success"
                  >{{
                    content.category
                      ? content.category.name
                      : typeof content.categoryId === "object"
                      ? content.categoryId.name
                      : ""
                  }}</va-lozenge>
                </div>
            </router-link>
            <div v-else>
                <va-lozenge
                  :class="
                    content.category || typeof content.categoryId === 'object'
                      ? ''
                      : 'invisible'
                  "
                  size="lg"
                  :uppercase="false"
                  type="success"
                  >{{
                    content.category
                      ? content.category.name
                      : typeof content.categoryId === "object"
                      ? content.categoryId.name
                      : ""
                  }}</va-lozenge>
                </div>
            <div class="text-right">
              <div
                v-if="content.type === 'premium' && content.discountedCourse"
                class="flex items-center justify-end mb-1"
              >
                <div class="line-through text-xxs opacity-30">
                  {{ thousandPrice(content.price) }}
                </div>
                <va-lozenge class="ml-1" :uppercase="true" type="danger"
                  >{{ content.discountedCourse.percentage }}%</va-lozenge
                >
              </div>
              <h4 class="th-text-primary">
                {{
                  content
                    ? content.type === "free"
                      ? "Gratis"
                      : content.discountedCourse
                      ? thousandPrice(content.discountedCourse.price)
                      : thousandPrice(content.price)
                    : "Rp 159.000"
                }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import Rating from '../Rating'
import BookmarkIcon from '@/components/Icon/Bookmark'
import thousandPrice from '@/helpers/thousandPrice'

export default {
  name: 'CardCourse1',
  components: {
    Rating,
    BookmarkIcon,
  },
  props: {
    content: {
      type: Object,
    },
    dataIsWishlist: {
      type: Boolean,
    },
  },
  methods: {
    toDetail() {
      // const id = this.content.key
      // this.$router.push({ name: 'Detail Course', params: { id } })
      this.$store.commit('SET_STATE', { currentMenu: '' })
    },
    async changeWishlist() {
      try {
        const sessionId = this.$cookies.get('sessionId')
        const routeNow = this.$route.path
        // console.log(routeNow)
        if (!sessionId) this.$router.push({ name: 'Masuk', query: { redirect: routeNow } })
        else {
          this.isClickedWishlist = !this.isClickedWishlist
          if (this.content?.key) {
            if (this.isClickedWishlist) {
              await this.$store.dispatch('course/ADD_TO_MY_WISHLIST', { courseId: this.content.key })
              this.notification.success({
                title: `Berhasil Memasukkan '${this.content.title}' Dalam Wishlist`,
                duration: 5000,
                // message: `
                //   <a href='/wishlist-saya'>
                //     Lihat Wishlist Saya
                //   </a>
                // `,
              })
            } else {
              await this.$store.dispatch('course/REMOVE_FROM_MY_WISHLIST', { courseId: this.content.key })
              this.notification.warning({
                title: `Berhasil Menghapus '${this.content.title}' Dalam Wishlist`,
                duration: 5000,
              })
            }

            if (this.$route.name === 'Wishlist Saya') this.$emit('fetchWishlist')
          }
        }
      } catch (err) {
        this.isClickedWishlist = !this.isClickedWishlist
        console.log(err)
      }
    },
    toWishlist() {
      this.$router.push({ name: 'Wishlist Saya' })
      this.$store.commit('SET_STATE', { currentMenu: 'Wishlist Saya' })
    },
  },
  data() {
    return {
      thousandPrice,
      isClickedWishlist: this.dataIsWishlist,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  watch: {
  },
  computed: {
    isDesktopView() { return !this.$store.state.isMobileView && !this.$store.state.isTabletView },
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";

.container-card-course-1 {
  // width: 300px;
  width: 100%;
  // max-width: 300px;
  // min-height: 300px;
  // overflow: hidden;
  z-index: 10;

  .wishlist-hover {
    opacity: 0;
  }

  .wishlist {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 14px;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 0 0 4px 4px;
    z-index: 11;
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;

    &.active {
      background: #3e4095;
    }
  }

  .image {
    position: relative;
    border-radius: $border-radius $border-radius 0 0;
    height: 160px;

    // &:before {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   width: 100%;
    //   height: 100%;
    //   top: 0;
    //   left: 0;
    //   background: linear-gradient(
    //     0deg,
    //     rgba(0, 0, 0, 0.51) 0%,
    //     rgba(255, 255, 255, 0) 100%
    //   );
    // }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    padding: 12px 14px 14px 14px;
    height: 150px;
    .title {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price-tag {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: auto;
      // margin-top: 8px;
    }
  }
}
</style>
